



















































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store";

// Vue components
import AuthActionsAlert from "@/components/AuthActions/AuthActionsAlert.vue";

// Model
import { getLicenseModuleLabel, defaultLicenseModuleEnumSorting, LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { getLicenseModuleIconColor } from "@/utility/Constants";
import { GetInstallationsResData } from "@/model/communication/device/GetInstallationsResData";
import { GetInstallationsEnabledModulesCommand } from "@/model/communication/license/GetInstallationsEnabledModulesCommand";
import { GetInstallationsEnabledModulesReqData, GetServerInstallationsEnabledModulesReqData } from "@/model/communication/license/GetInstallationsEnabledModulesReqData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        AuthActionsAlert,
    },
    data() {
        return {
            LicenseModuleEnum,
            loading: false,
            requiredInstallations: [],
        };
    },
    props: ["installations", "installationNames"],
    computed: {
        ...mapState({
            licensesDataSummary: (state: RootState) => state.license.licensesDataSummaryLocal,
        }),
        headers() {
            let headers = [];

            headers.push({ text: this.$t("common.installationName"), value: "name" });
            headers.push({ text: this.$t("common.branch"), value: "branch.name" });
            headers.push({ text: this.$t("common.last_installation_message"), value: "lastMessage" });

            // Moduli di licenza
            this.defaultLicenseModuleEnumSorting().forEach((moduleEnumValue) => {
                if (
                    this.licensesDataSummary.filter((c) => c.module == moduleEnumValue).length > 0 &&
                    this.licensesDataSummary.filter((c) => c.module == moduleEnumValue)[0].totalLicenses > 0
                )
                    headers.push({
                        value: LicenseModuleEnum[moduleEnumValue],
                        sortable: false,
                        align: "center",
                    });
            });

            return headers;
        },

        items() {
            if (this.installations) return this.installations;
            else if (this.installationNames) return this.requiredInstallations;
            else return [];
        },
    },
    methods: {
        getLicenseModuleLabel,
        defaultLicenseModuleEnumSorting,
        getLicenseModuleIconColor,

        onConfirm() {
            this.$emit("confirmed", this.items);
        },
    },
    async mounted() {
        // Richiedo le informazioni delle installazioni al server nel caso in cui sia in possesso solamente dei nomi
        if (this.installationNames != null && this.installations == null) {
            try {
                console.debug("Send request to get installation informations");
                this.loading = true;
                var request: GetInstallationsEnabledModulesReqData = new GetInstallationsEnabledModulesReqData();
                request.installationNames = this.installationNames;
                var response: GetInstallationsResData = await new GetInstallationsEnabledModulesCommand(GetServerInstallationsEnabledModulesReqData(request)).execute();
                this.loading = false;
                if (response.responseStatus == ApiResponseStatusEnum.Success) this.requiredInstallations = response.installations;
            } catch (e) {
                console.error("Something went wrong sending GetInstallationsEnabledModules request ", e);
                this.loading = false;
            }
        }
    },
});
